<template>
    <div class="container">
        <h2>{{email}}</h2>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-container grid-list-md>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-text-field
                                v-model="form.password"
                                :rules="passwordRules"
                                :label="$t('password')"
                                type="password"
                                required>
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field
                                v-model="form.passwordconfirm"
                                :rules="passwordConfirmationRules"
                                :label="$t('passwordconfirm')"
                                type="password"
                                required>
                        </v-text-field>
                    </v-flex>
                    <v-flex>
                        <div class="button-wrapper">
                            <v-btn :disabled="!valid" color="success" @click="submit">{{$t('Save')}}</v-btn>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-form>
    </div>
</template>
<script>
    import axios from 'axios';
    export default {
        data() {
            return {
                passwordRules: [
                    v => !!v || this.$t('Required field'),
                    v => (v && v.length >= 6) || this.$t('Must be at least 6 characters')
                ],
                passwordConfirmationRules: [
                    v => !!v || this.$t('Required field'),
                    (v) => v == this.form.password || this.$t('Password must match'),
                ],
                email: this.$route.query.email,
                valid: true,
                form: {
                    password: "",
                    passwordconfirm: ""
                }
            }
        },
        methods: {
            submit(){
                let headers = {
                    headers: {
                        token: this.$route.query.token
                    }
                };
                axios.post('/createUserPassword', {
                    password: this.form.password,
                    password_repeat: this.form.passwordconfirm
                }, headers)
                .then(response => {
                    if (response.status === 200) {
                        this.$router.push("login")
                    }
                })
                .catch(e => {
                    console.log(e);
                    //this.returnErrors.push(e)
                })
            }
        }
    }
</script>
<style scoped>
    .container {max-width: 600px;}

</style>



// WEBPACK FOOTER //
// src/views/account/SetPassword.vue